import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import VoiceSearchModal from './VoiceSearchModal';
import ViewBucket from './ViewBucket';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage, faArrowLeft, faMinus ,faPlus } from "@fortawesome/free-solid-svg-icons";
import RecentSearches from './RecentSearches';
import QuantityInput from "./KeypadQuantity";  



const ProductSearchOverlay = ({ isOpen, onClose, showBucket = true }) => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [allProducts, setAllProducts] = useState([]);
  const [showVoiceModal, setShowVoiceModal] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const [bucketProducts, setBucketProducts] = useState({});
  const [showViewBucket, setShowViewBucket] = useState(false);
  const bucketRef = useRef(null);
  const [placeholderIndex, setPlaceholderIndex] = useState(0);
     const [categories, setCategories] = useState([]);
     const [error, setError] = useState(null);
  const [productSubcategories, setProductSubcategories] = useState([]);
     


  const [recentSearches, setRecentSearches] = useState(
    JSON.parse(sessionStorage.getItem("recentSearches") || "[]")
  );

  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;

  const placeholders = [
  "Search for Cement",
  "Search for Adhesives",
  "Search for Electrical",
  "Search for Tile Allied",
  "Search for Paint & Accessories",
  "Search for Waterproofing Chemicals",
];

useEffect(() => {
  const total = placeholders.length;
  const interval = setInterval(() => {
    setPlaceholderIndex((prev) => {
      if (prev >= total) {
        setPlaceholderIndex(0);
        return 0;
      }
      return prev + 1;
    });
  }, 2000);
  return () => clearInterval(interval);
}, [placeholders.length]);



  const fetchAllItems = async () => {
    try {
      const token = sessionStorage.getItem('token') || '';
      const hubId = sessionStorage.getItem('hubId') || '';
      const response = await fetch(
        `${fetchUrl}product/get-all-products?hub_id=${hubId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        }
      );
      const data = await response.json();
      setAllProducts(data.success && data.data ? data.data : []);
    } catch (error) {
      console.error("Error fetching products:", error);
      setAllProducts([]);
    }
  };

   const fetchCategories = async () => {
    try {
      const response = await fetch(
        fetchUrl + "product-category/get-all-productCategories?is_ecommerce=true",
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );
  
      const data = await response.json();
      //console.log("Fetched categories:", data);
  
      if (data.success) {
        setCategories(data.data);
        return data.data;  
      } else {
        console.error("Failed to fetch categories:", data.message);
        setError("Failed to fetch categories");
        return [];  
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      setError("Error fetching categories");
      return [];  
    } 
    
  };

   const fetchAllSubcategories = async () => {
      try {
        const token = sessionStorage.getItem("token");
        const response = await fetch(
          `${fetchUrl}product-sub-category/get-all-productSubCategorys?`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-token": token,
            },
          }
        );
  
        const data = await response.json();
        console.log("Fetched all subcategories:", data);
  
        if (data.success) {
          setProductSubcategories(data.data || []);
        } else {
          setProductSubcategories([]);
        }
      } catch (error) {
        console.error("❌ Error fetching subcategories for multiple categories:", error);
      }
     
    };
  

 useEffect(() => {
  if (!isOpen) {
    setSearchQuery('');
    return;
  }

  // ✅ Fetch when user types something
  if (searchQuery.trim().length > 1) {
    fetchAllItems();
    fetchCategories();
    fetchAllSubcategories();
  }
}, [isOpen, searchQuery]);

const handleCategoryClick = (category) => {
  navigate("/consumer/productlist", {
    state: {
      categoryId: category.id,         
      categoryName: category.name,    
    },
  });
  onClose();
};

const handleSubcategoryClick = (subcategory) => {
  navigate("/consumer/productlist", {
    state: {
      categoryId: subcategory.parentCategoryId, // ✅ only parent category id
      categoryName: subcategory.parentCategoryName, // ✅ only parent category name
    },
  });
  onClose();
};


  useEffect(() => {
    if (isOpen) {
      const savedBucketProducts = localStorage.getItem("bucketProducts");
      if (savedBucketProducts) {
        const products = JSON.parse(savedBucketProducts);
        setBucketProducts(products);
        setShowViewBucket(Object.keys(products).length > 0);
      } else {
        setBucketProducts({});
        setShowViewBucket(false);
      }
    }
  }, [isOpen]);

  const handleVoiceSearch = () => setShowVoiceModal(true);
  const handleVoiceResult = (transcript) => setSearchQuery(transcript);
  const handleSearchChange = (e) => setSearchQuery(e.target.value);
  const handleClearSearch = () => setSearchQuery('');

  // ✅ New: Function to save items to recent searches
  const saveToRecent = (item) => {
    const existing = JSON.parse(sessionStorage.getItem("recentSearches") || "[]");
    const updated = [item, ...existing.filter((i) => i.id !== item.id)].slice(0, 10); 
    sessionStorage.setItem("recentSearches", JSON.stringify(updated));
    setRecentSearches(updated);
  };

  // Filter products based on search
 // ✅ Show results only when user starts typing (length > 1)
const searchResults =
  searchQuery.trim().length > 1
    ? [
        // 🔹 Categories (search match)
      ...categories
  .filter((c) =>
    c.product_category_name.toLowerCase().includes(searchQuery.toLowerCase())
  )
  .map((c) => ({
    id: c._id,
    name: c.product_category_name,
    type: "Category",
    image: null,
    fullCategory: c,
  })),

...productSubcategories
  .filter((sc) =>
    sc.product_sub_category_name.toLowerCase().includes(searchQuery.toLowerCase())
  )
  .map((sc) => ({
    id: sc._id,
    name: sc.product_sub_category_name,
    type: "Subcategory",
    image: null,
    // keep parent category info only
    parentCategoryId: sc.product_category_id?._id,
    parentCategoryName: sc.product_category_id?.product_category_name,
  })),


        // 🔹 Products (search match)
        ...allProducts
          .filter((p) =>
            p.product_name.toLowerCase().includes(searchQuery.toLowerCase())
          )
          .map((p) => ({
            id: p._id,
            name: p.product_name,
            image: p.product_image
              ? `${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${p.product_image}`
              : null,
            price: p.selling_price ? `₹${p.selling_price.toLocaleString('en-US')}` : "N/A",
            fullProduct: p,
            vendor_id: p.vendor_id,
            type: "Product",
          })),
      ]
    : []; // ✅ empty when no typing yet


  const handleProductClick = (item) => {
    saveToRecent({
      id: item.id,
      name: item.name,
      image: item.image,
      type: "Product"
    });
    navigate("/consumer/productinformation", {
      state: { product: item.fullProduct, vendor_id: item.vendor_id, relatedProducts: allProducts }
    });
    onClose();
  };

  const handleClearRecent = () => {
    sessionStorage.removeItem("recentSearches");
    setRecentSearches([]);
  };

 const handleRecentClick = (item) => {
  setSearchQuery(item.name); 
};


  const handleQuantityChange = (product, action, customQty = null) => {
  setBucketProducts((prev) => {
    const currentQty = prev[product.id]?.quantity || 0;
    let newQty = currentQty;

    if (action === "increase") newQty += 1;
    else if (action === "decrease") newQty = Math.max(0, currentQty - 1);
    else if (action === "add") newQty = 1;
    else if (action === "custom") newQty = customQty; // ✅ new keypad entry
    else if (action === "remove") newQty = 0;

    const updated = { ...prev };
    if (newQty > 0) updated[product.id] = { ...product.fullProduct, quantity: newQty };
    else delete updated[product.id];

    localStorage.setItem("bucketProducts", JSON.stringify(updated));
    setShowViewBucket(Object.keys(updated).length > 0);
    return updated;
  });
};


  if (!isOpen) return null;

 return (
  <div className="fixed inset-0 bg-gray-50 flex flex-col z-50">
    {/* Search Bar */}
    <div className="sticky top-0 bg-white z-20 p-3 shadow-sm">
      <div className="flex items-center bg-white rounded-md pl-3 p-3 space-x-1 border border-gray-200 shadow-sm mt-2">
       <FontAwesomeIcon
  icon={faArrowLeft}
  className="text-gray-600 cursor-pointer mr-2 flex-shrink-0 transform scale-x-148 text-[18px]"
  onClick={() => {
  onClose();
  setSearchQuery('');
  sessionStorage.setItem("overlayOpen", "false");
}}
/>

        <input
          type="text"
          value={searchQuery}
          onChange={handleSearchChange}
          autoFocus
          className="flex-1 bg-transparent text-gray-800 placeholder-gray-400 text-sm focus:outline-none"
        />

         {!searchQuery && (
    <div className="absolute left-14 top-[55%] transform -translate-y-1/2 overflow-hidden h-5 pointer-events-none">
      <div
        className={`flex flex-col ${
          placeholderIndex === 0 ? "" : "transition-transform duration-700 ease-in-out"
        }`}
        style={{
          transform: `translateY(-${placeholderIndex * 20}px)`,
        }}
      >
        {[...placeholders, ...placeholders].map((text, i) => (
          <span
            key={i}
            className="text-gray-400 text-sm leading-5"
            style={{ height: "20px" }}
          >
            {text}
          </span>
        ))}
      </div>
    </div>
  )}
        {searchQuery && (
          <>
            <button onClick={handleClearSearch} 
              className="flex items-center justify-center w-4 h-4 rounded-full bg-gray-400 hover:bg-gray-500 transition ml-1 ">
              <span className="text-white text-xs font-bold leading-none">×</span>
            </button>
            <div className="h-5 w-px bg-gray-300 mx-3 "></div>
          </>
        )}
        <svg xmlns="http://www.w3.org/2000/svg"
          className={`flex-none h-5 w-5 ${isListening ? "text-red-500" : "text-gray-500"} cursor-pointer`} 
          fill="none" viewBox="0 0 24 24" stroke="currentColor"
          onClick={handleVoiceSearch}>
          <path strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} d="M12 1a3 3 0 00-3 3v6a3 3 0 006 0V4a3 3 0 00-3-3zM19 11a7 7 0 01-14 0m7 7v4m0 0h-4m4 0h4"/>
        </svg>
      </div>
    </div>

  {/* Results */}
<div className="flex-1 overflow-y-auto px-2">
  {searchQuery.trim().length === 0 ? (
    recentSearches.length > 0 ? (
      <div className="mt-2 px-1">
        <RecentSearches
          recentSearches={recentSearches}
          onClear={handleClearRecent}
          onRecentClick={handleRecentClick}
        />
      </div>
    ) : (
      <div className="flex flex-col justify-start mt-10 items-center h-full text-center px-6">
        <svg xmlns="http://www.w3.org/2000/svg" 
          className="h-16 w-16 mb-4 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16h8M8 12h8m-8-4h8M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
        </svg>
        <p className="text-gray-500 text-base font-medium mb-1">
          Start typing or use voice search
        </p>
        <p className="text-gray-400 text-sm">
          to quickly find the products you need
        </p>
        {/* <button
          onClick={handleVoiceSearch}
          className="mt-4 px-4 py-2 bg-red-500 text-white rounded-md text-sm font-medium hover:bg-red-600 transition"
        >
          🎤 Use Voice Search
        </button> */}
      </div>
    )
  ) : searchResults.length === 0 ? (
    <div className="flex justify-center items-center h-40">
      <p className="text-gray-500 text-sm">No products found.</p>
    </div>
  ) : (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm mt-2">
   {searchResults.map((item, index) => {
  const currentQty = bucketProducts[item.id]?.quantity || 0;
  return (
    <div
      key={item.id}
      className={`flex items-center justify-between w-full p-3 ${
        index !== searchResults.length - 1 ? "border-b border-gray-200" : ""
      }`}
      onClick={() => {
        if (item.type === "Category") handleCategoryClick(item);
        else if (item.type === "Subcategory") handleSubcategoryClick(item);
        else handleProductClick(item);
      }}
    >
      <div className="flex items-center space-x-3 min-w-0 flex-1">
        {item.image ? (
          <img
            src={item.image}
            alt={item.name}
            className="h-12 w-12 rounded-md border border-gray-200 object-cover p-0.5 flex-shrink-0"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src =
                "https://placehold.co/100x100/A0A0A0/ffffff?text=No+Image";
            }}
          />
        ) : (
          <div className="w-12 h-12 rounded-md border border-gray-300 flex items-center justify-center">
            <FontAwesomeIcon icon={faImage} className="text-gray-400 text-xl" />
          </div>
        )}
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium text-gray-800 leading-tight break-words">
            {item.name}
          </p>

          {/* Only show price for products */}
          {item.type === "Product" && (
            <p className="text-[13px] mt-0.5 font-semibold text-gray-800">
              {item.price}
            </p>
          )}
        </div>
      </div>

      {/* Right Side: Add/Qty for Product OR Arrow for Category/Subcategory */}
      <div
        className="flex items-center justify-end w-[80px] flex-shrink-0"
        onClick={(e) => e.stopPropagation()}
      >
        {item.type === "Product" ? (
          currentQty > 0 ? (
            <div className="flex items-center justify-center bg-white border border-red-500 rounded-md px-1 py-0.5 w-full">
          <button
  onClick={(e) => {
    e.stopPropagation();
    handleQuantityChange(item, "decrease");
  }}
  className="text-white font-bold text-sm w-6 h-6 flex items-center justify-center rounded-full transition"
>
  <FontAwesomeIcon icon={faMinus} className="text-red-500 text-xs" />
</button>

<span className="text-xs font-bold text-red-500 mx-1 min-w-[20px]">
   <QuantityInput
    key={`${item.id}-${currentQty}`}
    initialQty={currentQty}
    onChange={(newQty) => {
      if (newQty > 0) handleQuantityChange(item, "custom", newQty);
    }}
  />
</span>

<button
  onClick={(e) => {
    e.stopPropagation();
    handleQuantityChange(item, "increase");
  }}
  className="text-white font-bold text-sm w-6 h-6 flex items-center justify-center rounded-full transition"
>
  <FontAwesomeIcon icon={faPlus} className="text-red-500 text-xs" />
</button>

            </div>
          ) : (
            <button
              onClick={() => handleQuantityChange(item, "add")}
              className="w-[70px] py-1 text-sm rounded-md bg-white border border-red-500 text-red-500 transition text-center flex-shrink-0"
            >
              Add
            </button>
          )
        ) : (
          // 👉 For Category / Subcategory: show right arrow
         <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-4 w-4 text-gray-400 cursor-pointer"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
      onClick={(e) => {
        e.stopPropagation(); // prevent outer click conflict
        if (item.type === "Category") handleCategoryClick(item);
        else if (item.type === "Subcategory") handleSubcategoryClick(item);
      }}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
    </svg>
        )}
      </div>
    </div>
  );
})}

    </div>
  )}
</div>



    {/* View Bucket at bottom */}
{showBucket && showViewBucket && (
  <div className="flex-shrink-0 px-3 pb-4 bg-gray-50">
    <ViewBucket
      bucketProducts={bucketProducts}
      imageUrl={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}
      bucketRef={bucketRef}
    />
  </div>
)}


    {/* Voice Modal */}
    <VoiceSearchModal
      isOpen={showVoiceModal} 
      onClose={() => setShowVoiceModal(false)}
      onResult={handleVoiceResult} 
    />
  </div>
);

};

export default ProductSearchOverlay;
